import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { PageHeader } from "@/components/ui/page-header";
import { PageContainer } from "@/components/ui/page-container";
import { PullToRefresh } from "@/components/ui/pull-to-refresh";
import DeviceList from "@/components/DeviceList";
import { EnrollDeviceDialog } from "@/components/device/EnrollDeviceDialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export default function DevicesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const statusFilter = searchParams.get("status");
  const searchQuery = searchParams.get("q") ?? "";
  const [isEnrollDialogOpen, setIsEnrollDialogOpen] = useState(false);

  const setStatusFilter = useCallback((status: string | null) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (status) next.set("status", status);
      else next.delete("status");
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  const setSearchQuery = useCallback((q: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (q) next.set("q", q);
      else next.delete("q");
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  const queryClient = useQueryClient();
  const handleRefresh = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ["devices"] });
  }, [queryClient]);

  return (
    <PageContainer>
      <PageHeader title="Devices" description="Manage and monitor your enrolled devices">
        <Button size="sm" onClick={() => setIsEnrollDialogOpen(true)}>
          <Plus className="mr-2 h-4 w-4" /> Enroll Device
        </Button>
      </PageHeader>

      <PullToRefresh onRefresh={handleRefresh}>
        <DeviceList
          statusFilter={statusFilter}
          onStatusClick={setStatusFilter}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />
      </PullToRefresh>

      <EnrollDeviceDialog isOpen={isEnrollDialogOpen} onClose={() => setIsEnrollDialogOpen(false)} />
    </PageContainer>
  );
}
